<template>
  <div>
    <div class="sayfahead">
      <h1>Destek Merkezi</h1>
    </div>
    <div class="icerik" >
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="borcliste vezne"  :style="'height:'+Height+'px' ">
            <el-select v-model="Tur" filterable @change="TalepGetir">
              <el-option
                v-for="item in Turler"
                :key="item.id"
                :label="item.Adi"
                :value="item.id">
              </el-option>
            </el-select>
            <el-input
              v-if="Talepler"
              placeholder="Arama"
              prefix-icon="el-icon-search"
              v-model="search">
            </el-input>
            <ul v-if="Talepler"  :style="'height:'+(Height-75)+'px' ">
              <li
                v-for="t in Talepler.filter(data => !search || data.Unvan.toLowerCase().includes(search.toLowerCase()))"
                @click="Talep_id=t.id" :class="t.id===Talep_id?'Aktif':''">
                <div class="kisiBilgi">
                  <span class="borcAd">{{t.Baslik}}</span>
                  <span class="borcBina">{{t.Unvan}}</span>
                  <span class="borcBina">{{t.tarih}}</span>
                </div>

              </li>
              <el-alert
                :closable="false"
                v-if="!Talepler.filter(data => !search || data.Baslik.toLowerCase().includes(search.toLowerCase()))[0]"
                title="Uygun Kayıt Bulunamadı"
                type="error">
              </el-alert>
            </ul>
          </div>
        </el-col>
        <el-col :span="18">
          <DestekDetay v-if="Talep_id" :id="this.Talep_id"></DestekDetay>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import Yukleniyor from "../../components/Doc/Yukleniyor";
  import DestekDetay from "./comp/DestekDetay";

  export default {
    components: {DestekDetay, Yukleniyor},
    data() {
      return {
        search: '',
        lo: false,
        Tur: 1,
        Talep_id: null,
        Turler: [
          {id: 2, Adi: 'Aktif Talepler'},
          {id: 1, Adi: 'Yeni Talepler'},
          {id: 3, Adi: 'Pasif Talepler'},
          {id: 4, Adi: 'Takvimdeki Talepler'},
          {id: 5, Adi: 'Cevap Bekleniyor'},
        ],
        Talepler: null,
        Height: window.innerHeight - 140,
      }
    },
    methods: {
      TalepGetir() {
        this.lo = true;
        this.$store.dispatch("Get", {path: '_a/t/talepler/' + this.Tur})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Talepler = response.Liste;
            }
          });
      }
    },
    created() {
      this.TalepGetir();
    }
  }
</script>

<style scoped>
  .Talepler {
    list-style: none;
    margin: 0;
    padding: 0;
    background: #dddfe7;
    border-radius: 0 0 4px 4px;
    margin-top: -10px;
    padding-top: 20px;
    padding-bottom: 20px;
    height: 77vh;
    overflow: scroll;
  }

  .Talepler li:last-child {
    border-bottom: 0;
  }

  .Talepler li.aktif {
    background-color: #00c391;
  }

  .Talepler li {
    padding: 10px;
    border-bottom: 1px solid #ccc;
    color: #333;
    font-size: 12px;
    cursor: pointer;
    height: 56px;
    line-height: 18px;
  }

  .Talepler li span.Baslik {
    display: block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .Talepler li span.Firma {
    float: left;
    width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 10px;
  }

  .Talepler li span.tarih {
    float: right;
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/_a/Destek.vue